import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import './Navbar.css';

const Navbar = ({ activeItem = 'Shop by Category' }) => {
  const shopDropdownItems = [
    { label: 'All Products', href: '#shop' },
    { label: 'Almonds', href: '#almonds' },
    { label: 'Cashews', href: '#cashews' },
    { label: 'Walnuts', href: '#walnuts' },
    { label: 'Pistachios', href: '#pistachios' },
    { label: 'Raisins', href: '#raisins' }
  ];

  const makhanaDropdownItems = [
    { label: 'Slow Roasted Makhana', href: '#makhana-roasted' },
    { label: 'Peri Peri Makhana', href: '#makhana-peri-peri' },
    { label: 'Mint & Salt Makhana', href: '#makhana-mint' },
    { label: 'Caramel Makhana', href: '#makhana-caramel' }
  ];

  return (
    <nav className="navbar-bg">
      <div className="container">
        <ul className="nav-links-list">
          <li>
            <a 
              href="/" 
              className={`nav-item-link ${activeItem === 'Home' ? 'active' : ''}`}
            >
              Home
            </a>
          </li>
          
          <li className="nav-dropdown">
            <a 
              href="/" 
              className={`nav-item-link ${activeItem === 'Shop' ? 'active' : ''}`}
            >
              Shop <ChevronDown size={14} />
            </a>
            <div className="dropdown-menu">
              {shopDropdownItems.map((item, idx) => (
                <a key={idx} href={item.href} className="dropdown-item-link">
                  {item.label}
                </a>
              ))}
            </div>
          </li>

          <li>
            <a 
              href="#shop-by-category" 
              className={`nav-item-link ${activeItem === 'Shop by Category' ? 'active' : ''}`}
            >
              Shop by Category
            </a>
          </li>

          <li>
            <a 
              href="#combo-offers" 
              className={`nav-item-link ${activeItem === 'Combo Offers' ? 'active' : ''}`}
            >
              Combo Offers
            </a>
          </li>

          <li className="nav-dropdown">
            <a 
              href="#makhana" 
              className={`nav-item-link ${activeItem === 'Makhana' ? 'active' : ''}`}
            >
              Makhana <ChevronDown size={14} />
            </a>
            <div className="dropdown-menu">
              {makhanaDropdownItems.map((item, idx) => (
                <a key={idx} href={item.href} className="dropdown-item-link">
                  {item.label}
                </a>
              ))}
            </div>
          </li>

          <li className="nav-item">
            <Link 
              to="/about-us" 
              className={`nav-item-link ${activeItem === 'About Us' ? 'active' : ''}`}
            >
              About Us
            </Link>
          </li>

          <li className="nav-item">
            <Link 
              to="/blog" 
              className={`nav-item-link ${activeItem === 'Blog' ? 'active' : ''}`}
            >
              Blog
            </Link>
          </li>

          <li className="nav-item">
            <Link 
              to="/contact" 
              className={`nav-item-link ${activeItem === 'Contact Us' ? 'active' : ''}`}
            >
              Contact Us
            </Link>
          </li>

          <li>
            <Link 
              to="/track" 
              className={`nav-item-link ${activeItem === 'Track Order' ? 'active' : ''}`}
            >
              Track Order
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
